import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AdvancedTopicsAccordion = () => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 0, fontWeight: 'bold', color: 'primary.main' }}>
        Assumptions
      </Typography>

      {/* Section 1: Calculation Methodology - COMMENTED OUT FOR LATER USE
      <Accordion sx={{ mb: 1, '&.Mui-expanded': { mb: 1, mt: 0 } }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: '#e3f2fd',
            minHeight: 'unset',
            '&.Mui-expanded': { minHeight: 'unset' },
            '& .MuiAccordionSummary-content': { my: 1 },
            '& .MuiAccordionSummary-content.Mui-expanded': { my: 1 },
            '&:hover': {
              backgroundColor: '#bbdefb'
            }
          }}
        >
          <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
            Calculation Methodology
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#fafafa' }}>
          <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 2 }}>
            [PLACEHOLDER - You will provide this content]
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 2 }}>
            This section will explain the dual-component framework overview, return component properties, and mathematical foundations (simplified from research paper).
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
            Include 4-6 paragraphs with key equations and explanations of how the calculator performs its analysis.
          </Typography>
        </AccordionDetails>
      </Accordion>
      */}

      {/* Section 3: Assumptions & Limitations */}
      <Accordion sx={{ mb: 1, '&.Mui-expanded': { mb: 1, mt: 0 } }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: '#e3f2fd',
            minHeight: 'unset',
            '&.Mui-expanded': { minHeight: 'unset' },
            '& .MuiAccordionSummary-content': { my: 1 },
            '& .MuiAccordionSummary-content.Mui-expanded': { my: 1 },
            '&:hover': {
              backgroundColor: '#bbdefb'
            }
          }}
        >
          <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
            Assumptions
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#fafafa' }}>
          <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 2 }}>
            This section explains key assumptions and limitations of the calculator, including:
          </Typography>
          <Box component="ul" sx={{ ml: 3, mb: 2 }}>
            <li>
              <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                <strong>Distribution assumptions:</strong> Savings converted to Roth are distributed proportionally to Traditional distributions over the user's life expectancy, plus 10-year heir distribution period.
                This is done for consistency since these Roth distributions replace Traditional dollars that would have been distributed if not for the conversion.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                <strong>Inflation adjustments:</strong> Tax brackets, standard deductions, Social Security benefits, and other parameters are annually adjusted to properly calculate future taxes, distribution tax rates and profits (losses).
              </Typography>
            </li>
            <li>
              <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                <strong>Life expectancy:</strong> This input is how many years you expect to live once your distributions start.  If you expect to live 20 years after distributions start, it might be safer to use 25 years so you're not broke your last fives years. 
              </Typography>
            </li>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default AdvancedTopicsAccordion;
